import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "./ui/dialog";
import { getEmbedUrl } from "../lib/api";
import { getExerciseImages } from "../config/exerciseImages";

export const ExerciseSheet = ({ exercise, open, onOpenChange }) => {
  const [zoom, setZoom] = useState(null);
  if (!exercise) return null;
  const embed = getEmbedUrl(exercise.video_url);
  const images = getExerciseImages(exercise.name);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-md rounded-3xl border-none bg-cream p-6"
        data-testid="exercise-sheet"
      >
        <DialogHeader>
          <DialogTitle className="text-left font-serif text-2xl font-bold text-ink">
            {exercise.name}
          </DialogTitle>
        </DialogHeader>

        {images.length > 0 && (
          <div
            className={`mt-2 grid gap-3 ${images.length === 2 ? "grid-cols-2" : "grid-cols-1"}`}
            data-testid="exercise-images"
          >
            {images.map((img) => (
              <figure key={img.src} className={images.length === 1 ? "mx-auto w-full" : ""}>
                <button
                  type="button"
                  onClick={() => setZoom(img)}
                  className="block w-full overflow-hidden rounded-xl bg-ink/5"
                  style={{ borderRadius: "12px", aspectRatio: "3 / 2" }}
                  data-testid={`exercise-image-${img.label ? img.label.toLowerCase() : "single"}`}
                  aria-label={img.alt}
                >
                  <img
                    src={img.src}
                    alt={img.alt}
                    loading="lazy"
                    className="h-full w-full object-cover"
                  />
                </button>
                {img.label && (
                  <figcaption className="mt-1 text-center text-xs font-medium text-ink/55">
                    {img.label}
                  </figcaption>
                )}
              </figure>
            ))}
          </div>
        )}

        {embed && (
          <div className="mt-3 aspect-video w-full overflow-hidden rounded-2xl bg-ink/5" data-testid="exercise-video">
            <iframe
              src={embed}
              title={exercise.name}
              className="h-full w-full"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        )}

        <DialogDescription className="mt-3 text-sm leading-relaxed text-ink/80" data-testid="exercise-instructions">
          {exercise.instructions}
        </DialogDescription>

        {zoom && (
          <div
            className="fixed inset-0 z-[60] flex items-center justify-center bg-black/80 p-6"
            onClick={() => setZoom(null)}
            data-testid="exercise-lightbox"
          >
            <img
              src={zoom.src}
              alt={zoom.alt}
              className="max-h-[85vh] max-w-full rounded-xl object-contain"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
